import { html } from "lit";

interface ViewAllBlockProps {
    asButton?: boolean;
    icon?: string | null;
    shadow?: boolean;
    tab?: string;
    text?: string;
}

export const ViewAllBlockTemplate = ({
    asButton,
    icon,
    shadow,
    tab,
    text = "Mehr anzeigen",
}: ViewAllBlockProps) => {
    const classNames = ["ux-iws-view-all-block"];
    if (asButton) {
        classNames.push("ux-iws-view-all-block--as-button");
    }
    if (shadow) {
        classNames.push("ux-iws-view-all-block--with-shadow");
    }
    const iconHtml = icon ? html`<ux-icon name="${icon}"></ux-icon>` : html``;
    return html`
        <a class="${classNames.join(" ")}" href="#" data-ux-tab-target="${tab}">
            ${iconHtml}
            <span class="ux-u-text-bold ux-u-text-align--center">${text}</span>
        </a>
    `;
};
